// ShowChangeK85Block.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Table, Button } from 'react-bootstrap';
import { getInfoAboutEdit } from './actions';

const text = "Інформація щодо редагування та перегляду звіту";

const tableschema = [
    { h: "#", f: "index" },
    { h: "Дата", f: "date" },
    { h: "Дія", f: "type" },
    { h: "Ім'я", f: "fullname" },
    { h: "Роль", f: "role" }
];

const rolenames = {
    'superadmin': 'Адміністратор+',
    'admin': 'Адміністратор',
    'moderator': 'Модератор'
};

const prepareData = (d) => {
    const { data } = d;

    if(!Array.isArray(data) || data.length < 1) return [];

    const result = [];

    const addElement = (e, t) => {
        const { lastEdit, firstEdit, fullname, role } = e;
        const date = new Date(lastEdit ? lastEdit : firstEdit).toLocaleDateString('uk');
        const time = new Date(lastEdit ? lastEdit : firstEdit).toLocaleTimeString('uk');
        
        const row = {
            index: result.length,
            date: `${date} ${time}`,
            type: t === 'editors' ? 'Редагування' : 'Перегляд',
            fullname: fullname,
            role: rolenames[role]
        };

        result.push(row);
    };

    data.forEach(r => {
        const { accessUsers } = r;
        const { editors, viewers } = accessUsers;

        editors.forEach(e => addElement(e, 'editors'));
        viewers.forEach(e => addElement(e, 'viewers'));
    });

    return result;
};

const ShowChangeK85Block = ({ show, data, close }) => {
    const [tableData, setTableData] = useState([]);

    const setInfo = useCallback((info) => setTableData(prepareData(info)), []);

    useEffect(() => {
        if(show && data._id) {
            getInfoAboutEdit(data, setInfo, (err) => alert(`Помилка при отриманні інформації`));
        }
    }, [show, data, setInfo]);

    return (
        <Modal show={show} onHide={close} size="lg" className="k85-modal">
            <Modal.Header closeButton>
                <Modal.Title>{text}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="table-responsive">
                    <Table striped hover>
                        <thead className="table-light">
                            <tr>
                                {tableschema.map((th, index) => 
                                    <th key={index}>{th.h}</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((d, index) => (
                                <tr key={index}>
                                    {tableschema.map((s, idx) => 
                                        <td key={idx}>{d[s.f]}</td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={close}>Закрити</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ShowChangeK85Block;